export const refreshProductionSidebar = () => {
  window.dispatchEvent(new Event("production-sidebar-refresh"));
};